<template>
    <div class="az-form-content">
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex az-form-content>
                    <div class="az-text" v-if="!editando">
                      <painel-linha-fornecimento-visualizacao v-model="linhasFornecimento"/>
                    </div>
                    <painel-linha-fornecimento-edicao v-model="linhasFornecimento"
                                                      v-if="editando"
                                                      @adicionarLinhaFornecimento="tratarEventoAdicionarLinha"
                                                      @excluirLinhaFornecimento="tratarEventoExclusaoLinha"/>
                </v-flex>
                <v-flex xs12 sm3 d-flex class="py-0">
                    <v-text-field name="Numero do Edital" label="Número do Edital *" placeholder="Ex. 123/2018"
                                  v-model="value.numeroEdital"
                                  v-validate="'required|max:20'"
                                  v-if="editando"
                                  :error-messages="errors.collect('Numero do Edital')"
                                  :disabled="!editando || deveBloquearEdicaoEdital"
                    ></v-text-field>
                    <div class="az-text dados-edital-numero-edital" v-if="!editando && value.numeroEdital">
                        <label>Numero do Edital</label>
                        <p class="mb-0">{{value.numeroEdital}}</p>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="anexos.length > 0">
                    <span class="az-subtitle primary--text">Anexos do Edital</span>
                </v-flex>
                <v-flex xs12 sm12 class="text-xs-center" v-if="anexos.length > 0 && editando && value.publicado && !ehFornecedor">
                    <v-btn small color="primary" class="ml-0" @click="exibirModalPncp = true">
                        Reenviar documento PNCP
                    </v-btn>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="editando">
                    <edl-file-upload :accept="arquivosAceitos" :repository="repository" ref="azFileUploadEdital" v-show="editando">
                        <a @click.prevent="$refs.azFileUploadEdital.openFileSelector()">
                            <v-icon>archive</v-icon>
                            Importar Arquivos
                        </a>
                        <p>Arraste e solte os arquivos aqui para serem carregados.</p>
                    </edl-file-upload>
                </v-flex>
                <v-flex xs12 sm12 d-flex class="mb-5">
                    <v-data-table v-if="anexos.length > 0"
                                  :headers="colunasTabela"
                                  :items="anexos"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-edital"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td class="table-status__error coluna-documento-edital">
                                    <div style="display: inline-flex; width: 30px;">
                                        <v-tooltip top v-if="!props.item.tipo">
                                            <v-icon class="pa-0" slot="activator">error_outline</v-icon>
                                            <span>Informe o tipo do anexo</span>
                                        </v-tooltip>
                                        <v-tooltip top v-if="!isAceitoPNCP(props.item)">
                                          <v-icon class="ml-1 pa-0" slot="activator">warning_outline</v-icon>
                                          <span>Este anexo não será enviado para o PNCP pois o formato não é aceito</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td class="coluna-documento-edital">
                                    <span v-if="props.item.relatorioNome">{{ props.item.relatorioNome}}</span>
                                    <span v-else-if="props.item.tipo">{{ props.item.tipo | tipoAnexo }}</span>
                                    <span v-else>--</span>
                                </td>
                                <td class="coluna-documento-edital">
                                    <v-select v-if="isSelectTipoHabilitado(props.item)"
                                              :items="tiposAnexo.filter(tipo=>!tipo.oculto)"
                                              v-model="props.item.tipo"
                                              item-text="label"
                                              item-value="chave" align="center"
                                    >
                                    </v-select>
                                    <span v-else>{{ props.item.tipo | tipoAnexo }}</span>
                                </td>
                                <td class="coluna-documento-edital">
                                    <span>{{ props.item.dataCadastro | az-date('DD/MM/YYYY HH:mm') }}</span>
                                </td>
                                <td class="coluna-documento-edital">{{ props.item.arquivoNome }}</td>
                                <td class="coluna-documento-edital">{{retornaDescricaoSituacaoAnexo(props.item.situacao)}}</td>
                              <td class="coluna-documento-edital">
                                <div v-if="props.item.situacao === 'INATIVO'">
                                  Não enviado
                                </div>
                                <div v-else-if="props.item.situacaoEnvio">
                                  {{ props.item.situacaoEnvio | situacaoEnvioAnexo }}
                                  <v-tooltip top v-if="props.item.situacaoEnvio !== 'PUBLICADO' && props.item.motivo">
                                    <v-icon class="pa-0" slot="activator">info</v-icon>
                                    <span>{{ props.item.motivo }}</span>
                                  </v-tooltip>
                                </div>

                                <span v-else>Processando</span>
                              </td>
                                <td class="table-actions">
                                    <div>
                                        <a @click="baixarArquivo(props.item)" v-if="props.item.id" title="Download do Anexo"
                                           target="_blank" class="az-action-link-icon">
                                            <v-icon>get_app</v-icon>
                                        </a>
                                        <v-tooltip top>
                                          <a slot="activator" @click.prevent="emitirInativarAnexo(props.item)" v-if="editando && props.item.situacao === 'ATIVO'">
                                            <v-icon :class="anexoEstaBloqueado(props.item) ? 'desativado' : '' ">visibility_off</v-icon>
                                          </a>
                                          <span v-if="anexoEstaBloqueado(props.item)">Aguarde</span>
                                          <span v-else>Alterar acesso público</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <a slot="activator" @click.prevent="emitirAtivarAnexo(props.item)" v-if="editando && props.item.situacao === 'INATIVO'">
                                              <v-icon :class="anexoEstaBloqueado(props.item) ? 'desativado' : '' ">visibility</v-icon>
                                          </a>
                                          <span v-if="anexoEstaBloqueado(props.item)">Aguarde</span>
                                          <span v-else>Alterar acesso público</span>
                                        </v-tooltip>
                                        <a @click.prevent="$emit('onRemoverAnexo', props.item)" v-if="editando && (value.publicado === false || value.publicado === null)" title="Remover Anexo">
                                            <v-icon>close</v-icon>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="!anexos.length && !editando">
                    <az-ops title="Ops! Nenhum anexo encontrado."
                            message="Utilize o botão importar com a tela em modo de edição para adicionar anexos"
                    ></az-ops>
                </v-flex>
            </v-layout>
        </v-container>
        <modal-reenviar-documento-pncp
            :exibir="exibirModalPncp"
            :anexos="anexos"
            @fechar="exibirModalPncp = false"
            @reenviar="reenviarDocumentosPncp"
        />
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {actionTypes, tiposAnexo, formatosAceitosPncp} from '@/commons/constants'
    import {AzSoundex} from '@azinformatica/loki'
    import EdlFileUpload from '@/commons/components/file/EdlFileUpload'
    import PainelLinhaFornecimentoEdicao from '@/commons/components/PainelLinhaFornecimentoEdicao.vue'
    import PainelLinhaFornecimentoVisualizacao from "@/commons/components/PainelLinhaFornecimentoVisualizacao.vue";
    import ModalReenviarDocumentoPncp from './ModalReenviarDocumentoPncp'

    export default {
        name: 'DadosEdital',
      components: {EdlFileUpload, PainelLinhaFornecimentoEdicao, PainelLinhaFornecimentoVisualizacao, ModalReenviarDocumentoPncp},
      inject: ['$validator'],
        props: {
            editando: {
                type: Boolean,
                default: false
            },
            value: {
                required: true
            },
            anexosBloqueadosAtivarInativar: {
                type: Array,
                default: () => {
                  return []
                }
            }
        },
        data() {
            return {
                colunasTabela: [
                    {
                        text: '',
                        align: 'left',
                        sortable: false,
                        width: '30px'
                    },
                    {
                        text: 'Relatório',
                        align: 'left',
                        sortable: false,
                        width: '250px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Tipo',
                        align: 'left',
                        sortable: false,
                        width: '250px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Data',
                        align: 'left',
                        sortable: false,
                        width: '150px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Nome',
                        sortable: false,
                        align: 'left',
                        width: '250px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Acesso Público',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Situação PNCP',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'center',
                        width: '150px',
                        class: 'primary--text'
                    }
                ],
                licitacaoId: null,
                repository: 'repo1:licitacao',
                soundexTiposAnexo: [],
                taxaSemelhancaMinimaAceitavelTipoAnexo: 0.5,
                tiposAnexo,
                linhasFornecimento: [],
                exibirModalPncp: false
            }
        },
        computed: {
            anexos() {
                const anexosLicitacao = this.anexosLicitacao.filter(doc => doc.tipo !== 'TERMO_DESENTRANHAMENTO')
                const uploadedFiles = this.loki.uploadedFiles

                for (let i = 0; i < uploadedFiles.length; i++) {
                    const file = uploadedFiles[i]
                    file.arquivoUri = file.uri
                    file.arquivoNome = file.name
                    file.tipo = this.inferirTipoAnexo(file)
                }

                return anexosLicitacao.concat(uploadedFiles)
            },
            arquivosAceitos() {
              return this.parametros.propriedadesLicitacao.extensao
            },
            deveBloquearEdicaoEdital(){
              return (this.value.numRepeticao && this.value.numRepeticao > 0)
                  || this.value.publicado || this.value.bloquearEdicaoNumEdital
            },
            ehFornecedor() {
              return this.$store.state.loki.user.type === 'EXTERNO'
            },
            ...mapState(['loki', 'licitacao', 'anexosLicitacao', 'parametros'])
        },
        async mounted() {
            this.loki.uploadedFiles = []
            this.setLicitacaoId(this.$route.params.id)
            this.gerarSoundexParaTiposAnexo()
            await this.buscarLinhaFornecimento()
        },
        methods: {
            isAceitoPNCP(anexo){
              if(this.value.amparoLegal && !this.value.amparoLegal.pncp){
                return true
              }
              const formato = anexo.arquivoNome.split('.').pop()
              return formatosAceitosPncp.includes(formato);
            },
            anexoEstaBloqueado(anexo){
                return this.anexosBloqueadosAtivarInativar.some(anexoId => anexoId === anexo.id)
            },
            emitirInativarAnexo(anexo){
              if(this.anexosBloqueadosAtivarInativar.includes(anexo.id)){
                return
              }
              this.$emit('onInativarAnexo', anexo)
            },
            emitirAtivarAnexo(anexo){
              if(this.anexosBloqueadosAtivarInativar.includes(anexo.id)){
                return
              }
              this.$emit('onAtivarAnexo', anexo)
            },
            gerarSoundexParaTiposAnexo() {
                this.tiposAnexo.filter(tipo=>!tipo.oculto).forEach(tipo => {
                    const soundex = AzSoundex.gerarSoundex(tipo.chave.toLowerCase(), true)
                    this.soundexTiposAnexo.push(soundex)
                    tipo.soundex = soundex
                })
            },
            inferirTipoAnexo(anexo) {
                const nomeArquivo = this.limparNomeArquivo(anexo.name)
                const soundexNomeArquivo = AzSoundex.gerarSoundex(nomeArquivo.toLowerCase(), true)
                const soundexMaisParecido = AzSoundex.selecionarMaisParecido(this.soundexTiposAnexo, soundexNomeArquivo)
                if (soundexMaisParecido.bestMatch.rating < this.taxaSemelhancaMinimaAceitavelTipoAnexo) {
                    return undefined
                }
                const tipoInferido = this.tiposAnexo.filter(tipo=>!tipo.oculto).find(tipo => tipo.soundex === soundexMaisParecido.bestMatch.target)
                return tipoInferido.chave
            },
            isSelectTipoHabilitado(item) {
                return !item.id && this.editando
            },
            limparNomeArquivo(nomeAnexo) {
                const nomeSemNumeros = nomeAnexo.replace(/[0-9]/g, '')
                const qtdCaracteresNomeArquivo = nomeSemNumeros.length - Math.abs(nomeSemNumeros.length - nomeSemNumeros.lastIndexOf('.'))
                return nomeSemNumeros.substr(0, qtdCaracteresNomeArquivo)
            },
            retornaDescricaoSituacaoAnexo(situacao){
                if(situacao === 'ATIVO'){
                    return 'Sim'
                } else {
                    return 'Não'
                }
            },
            async baixarArquivo(doc) {
                const payload = {
                  licitacaoId: this.licitacao.id,
                  documentoVirtualizadoId: doc.idVirtualizado,
                  nomeArquivo: doc.arquivoNome,
                  externo: doc.externo,
                  uri: doc.arquivoUri,
                  tipoAnexo : doc.tipo
                }
                await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_ARQUIVO_USUARIO_LOGADO, payload)
            },
            async tratarEventoAdicionarLinha(linha) {
                const objLinha = {
                  linha
                }
                const licitacaoId = this.licitacaoId
                await this.$store.dispatch(actionTypes.ADICIONAR_LINHA_FORNECIMENTO, {licitacaoId, objLinha})
                await this.buscarLinhaFornecimento()
            },
            async tratarEventoExclusaoLinha(linhaId) {
                const licitacaoId = this.licitacaoId
                await this.$store.dispatch(actionTypes.REMOVER_LINHA_FORNECIMENTO, {licitacaoId, linhaId})
                this.mostrarNotificacaoSucesso('Linha de fornecimento excluída com sucesso.')
                await this.buscarLinhaFornecimento()
            },
            async buscarLinhaFornecimento() {
              this.habilitarLoadingGlobal()
              this.setMensagemLoading('Atualizando linhas de fornecimento...')
              this.linhasFornecimento = await this.buscarLinhasFornecimento(this.licitacaoId)
              this.desabilitarLoadingGlobal()
            },
            setLicitacaoId(licitacaoId) {
              this.licitacaoId = licitacaoId
            },
            reenviarDocumentosPncp(anexosComErro) {
              this.$emit('onReenviarDocumentosPncp', { anexosComErro, licitacaoId: this.licitacao.id })
            },
            ...mapActions([actionTypes.BUSCAR_QTD_PROPOSTAS_POR_LICITACAO, actionTypes.BUSCAR_LINHAS_FORNECIMENTO])
        },
        filters: {
            tipoAnexo(tipoAnexoChave) {
                const tipoSelecionado = tiposAnexo.filter(tipo=>!tipo.oculto).find(tipoObj => tipoObj.chave === tipoAnexoChave)
                return tipoSelecionado ? tipoSelecionado.label : ''
            },
            situacaoEnvioAnexo(situacao) {
                const situacoes = {
                    'PUBLICADO': 'Publicado',
                    'ERRO': 'Erro',
                    'NAO_ENVIADO': 'Não enviado'
                }
                return situacoes[situacao] || situacao || '--'
            }
        }
    }
</script>

<style scoped lang="stylus">
    .desativado
      opacity 0.5

    .table-status
        &__error i
            font-size: 18px
            color: #d79641

    @media (max-width: 720px)
        .table-dados-edital

            td:nth-of-type(1):before
                display none

            td:nth-of-type(2):before
                content: "Tipo:"

            td:nth-of-type(3):before
                content: "Data:"

            td:nth-of-type(4):before
                content: "Nome:"

            td:nth-of-type(5):before
                display none

  .coluna-documento-edital
    padding-left 10px !important

</style>
